module.exports = __webpack_public_path__ + "resources/img/img_intro_certi6.40dea15915e57671a39ab61898744d26.png";